import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/GiftCards.css";

/*
  Gift Cards Page

  Purpose:
  Displays the gift card widget inside a styled card while keeping
  all third party code isolated inside an iframe.

  Height Handling:
  - The iframe posts its rendered height via postMessage
  - React resizes the iframe only
  - No global resize listeners are used
*/

export default function GiftCards() {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(720);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type !== "BOOKAPP_GIFT_HEIGHT") return;

      if (typeof event.data.height === "number") {
        setIframeHeight(Math.max(event.data.height, 520));
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <main className="giftcards-container">
      <Helmet>
        <title>Gift Cards | Lash With Brittany</title>
        <meta
          name="description"
          content="Give the gift of beautiful lashes or permanent jewelry. Digital gift cards available instantly."
        />
        <link rel="canonical" href="https://lashwithbrittany.com/giftcards" />
      </Helmet>

      <section className="giftcards-intro">
        <h1>Gift Cards for Lash With Brittany Beauty Services in Rochester NY</h1>

        <p className="giftcards-subtitle">
          Perfect for any occasion
        </p>

        <p className="giftcards-description">
          Choose a gift amount and send it instantly. Gift cards can be used
          toward any service or product at Lash With Brittany.
        </p>
      </section>

      <div className="giftcards-widget-shell">
        <div className="giftcards-card">
          <iframe
            ref={iframeRef}
            src="/giftcards-embed.html"
            title="Gift Cards"
            className="giftcards-iframe"
            style={{ height: iframeHeight }}
            scrolling="no"
          />
        </div>
      </div>
    </main>
  );
}
